import { CategoryCarouselProps } from "@bluebottlecoffee/design-system/components";
import { CategoryCarousel as Schema } from "../sanity-schema";
import { toCategoryCardProps } from "./category-card";

export function toCategoryCarouselProps(
  data: Schema,
  region: string,
  lang: string,
): CategoryCarouselProps {
  return {
    ...(data.bgColor && { bgColor: data.bgColor }),
    categoryCards: data.categoryCards.map((c) =>
      toCategoryCardProps(c, region, lang, data.bgColor),
    ),
  };
}
